import { useEffect, useState } from "react";
import { toast } from "sonner";
import { UploadCloud, CheckCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const BulkPublish = ({ onDone }) => {
  const [busy, setBusy] = useState("");
  const [result, setResult] = useState(null);
  const [hook, setHook] = useState(false);
  useEffect(() => { api.get("/store/settings").then((r) => setHook(r.data.connected)).catch(() => {}); }, []);
  const run = async (path, ok) => {
    setBusy(path);
    try {
      const { data } = await api.post(path);
      if (path === "/store/push-all") setResult(data);
      toast.success(ok(data));
      onDone?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  return (
    <div data-testid="bulk-publish-panel" className="bg-[#F4EFE6] border border-[#E2D9CC] p-6 space-y-4">
      <h2 className="font-display text-2xl text-[#3B1B48]">All guides at once</h2>
      <p className="text-sm text-[#8C827A]">"Publish all built" makes every finished guide live (public map pin, changelog and free sample) and creates a map Story post. Your shop reads published guides automatically, so nothing else is needed.{hook && " \"Push all to store\" also notifies your optional webhook."}</p>
      <div className="flex flex-wrap gap-3">
        <Button data-testid="publish-all-button" variant="outline" disabled={!!busy} onClick={() => run("/guides/publish-all", (d) => `${d.published} guides published`)} className="rounded-none"><CheckCheck className="w-4 h-4 mr-2" />{busy === "/guides/publish-all" ? "Publishing…" : "Publish all built"}</Button>
        {hook && <Button data-testid="push-all-button" disabled={!!busy} onClick={() => run("/store/push-all", (d) => `${d.pushed} sent to the store${d.failed ? `, ${d.failed} failed` : ""}`)} className="rounded-none"><UploadCloud className="w-4 h-4 mr-2" />{busy === "/store/push-all" ? "Sending…" : "Push all to store"}</Button>}
      </div>
      {result?.results?.some((r) => !r.ok) && (
        <ul data-testid="push-all-errors" className="text-xs text-[#B42318] space-y-1">{result.results.filter((r) => !r.ok).map((r) => <li key={r.town}>{r.town}: {r.error || `HTTP ${r.status_code}`}</li>)}</ul>
      )}
    </div>
  );
};
